module.exports = __webpack_public_path__ + "img/basic_icon.ee914306.png";